// extracted by mini-css-extract-plugin
module.exports = {"phones":"_8c559fa4c7--phones--WwRMG","phones-animation":"_8c559fa4c7--phones-animation--zu6eq","to-open-phones-animation":"_8c559fa4c7--to-open-phones-animation--gAXqs"};